














































































































































































































































































































































import { Component, Vue, Prop, Emit, Watch } from "vue-property-decorator";
import AgroGenericModal from "@/components/agroGenericModal/AgroGenericModal.vue";
import AgroIcons from "@/components/agroIcons/AgroIcons.vue";
import FileUploadFarm from "../file-upload-farm/FileUploadFarm.vue";
import BulkUploaderValidator from "../bulk-uploader-validator/BulkUploaderValidator.vue";
import { BulkUploadDTO } from "@/api/bulk/types";
import * as notificationService from "@/services/notification/index";
import i18n from "@/i18n";

@Component({
  name: "ModalUploadFarm",
  components: {
    icon: AgroIcons,
    AgroGenericModal,
    FileUpload: FileUploadFarm,
    BulkUploaderValidator: BulkUploaderValidator 
  },
})
export default class ModalUploadFarm extends Vue {
  @Prop({ type: Boolean, default: false }) private readonly isVisible!: boolean;

  private FARM_NAME = "farm_name";
  private OWNER_NAME = "owner_name";
  private OWNER_ID = "owner_id";
  private CROP_TYPE_1 = "crop_type_1";
  private CROP_TYPE_2 = "crop_type_2";
  private SENTINELA = "sentinela";
  private ANALITICA = "analitica";
  private CAR = "car_code";
  private SIGEF = "incra_allotment";
  private GEOM = "geom";

  private POINT = "point";
  private LNG = "lng";
  private LAT = "lat";

  private GEOJSON_EXAMPLE =
    '{"type":"Polygon","coordinates":[[[-51.908512115478516,-17.351703400381574],[-51.90765380859375,-17.351703400381574],[-51.90765380859375,-17.350925113977652],[-51.908512115478516,-17.350925113977652],[-51.908512115478516,-17.351703400381574]]]}';

  private selectedFields: string[] = [];
  private selectedCropTypes: string[] = [];
  private selectedProducts: string[] = [];

  private records: BulkUploadDTO[] = [];
  private isFileUploadVisible: boolean = false;
  private farmShapeType: string = this.CAR;

  private confirmAction() {
    this.isFileUploadVisible = true;
    this.emitConfirmAction();
  }

  private cancelAction() {
    this.cleanSelectedOptions();
    this.emitCancelAction();
  }

  get farmers() {
    return [this.OWNER_NAME, "Júlio César", "Jéssica Alagoas", "Juliano Matos"];
  }

  get farms() {
    return [
      this.FARM_NAME,
      "Fazenda Alegrete",
      "Fazenda Oeste",
      "Fazenda Solar",
    ];
  }

  get ownersId() {
    return [this.OWNER_ID, "123456789", "rodrigo@email.com", "4423889"];
  }

  get lngs() {
    return [this.LNG, -43.1298442, -54.33448934, -49.978822343];
  }

  get lats() {
    return [this.LAT, -20.9753444, -12.97322109, -17.97998332];
  }

  get cropTypes1() {
    return [this.CROP_TYPE_1, "SOY", "SOY", "SOY"];
  }

  get cropTypes2() {
    return [this.CROP_TYPE_2, "CORN", "CORN", "CORN"];
  }

  get sentinela() {
    return [this.SENTINELA, true, true, true];
  }

  get analitica() {
    return [this.ANALITICA, true, true, true];
  }

  get geoms() {
    const pol = '{"type":"Polygon","coordinates":[[...]]}';
    return [this.GEOM, pol, pol, pol];
  }

  get cars() {
    return [
      this.CAR,
      "MT-5102686-C9C3547291E2423885688E0111111111",
      "MT-5102686-C9C3547291E2423885688E0122222222",
      "MT-5102686-C9C3547291E2423885688E0133333333",
    ];
  }

  get sigefs() {
    return [
      this.SIGEF,
      "7f3faf82-945d-4ba6-85a2-f8f08b7f04cc",
      "4131b87d-8c87-47e9-a1f1-c0c64157fa03",
      "f25184c1-7435-4b83-be37-5e3130431954",
    ];
  }

  private getLine(l: number) {
    let line = "";
    if (this.selectedFields.includes(this.FARM_NAME)) {
      line += `${this.farms[l]};`;
    }
    if (this.selectedFields.includes(this.OWNER_NAME)) {
      line += `${this.farmers[l]};`;
    }
    if (this.selectedFields.includes(this.OWNER_ID)) {
      line += `${this.ownersId[l]};`;
    }
    if (this.selectedFields.includes(this.CAR)) {
      line += `${this.cars[l]};`;
    }
    if (this.selectedFields.includes(this.SIGEF)) {
      line += `${this.sigefs[l]};`;
    }

    if (this.farmShapeType === this.POINT) {
      line += `${this.lngs[l]};`;
      line += `${this.lats[l]};`;
    } else if (this.farmShapeType === this.GEOM) {
      line += `${this.geoms[l]};`;
    } else if (this.farmShapeType === this.CAR) {
      line += `${this.cars[l]};`;
    } else if (this.farmShapeType === this.SIGEF) {
      line += `${this.sigefs[l]};`;
    }

    if (this.selectedCropTypes.includes(this.CROP_TYPE_1)) {
      line += `${this.cropTypes1[l]};`;
    }
    if (this.selectedCropTypes.includes(this.CROP_TYPE_2)) {
      line += `${this.cropTypes2[l]};`;
    }
    if (this.selectedProducts.includes(this.SENTINELA)) {
      line += `${this.sentinela[l]};`;
    }
    if (this.selectedProducts.includes(this.ANALITICA)) {
      line += `${this.analitica[l]};`;
    }

    return line;
  }

  @Emit("onconfirm")
  private emitConfirmAction() {}

  @Emit("oncancel")
  private emitCancelAction() {
    this.records = [];
  }

  private cleanSelectedOptions() {
    this.selectedFields = [];
    this.selectedProducts = [];
    this.records = [];
  }

  @Watch("farmShapeType", { immediate: true })
  private changeFarmShapeType() {
    if (
      this.farmShapeType === this.GEOM &&
      !this.selectedFields.includes(this.FARM_NAME)
    ) {
      this.selectedFields.push(this.FARM_NAME);
    }
  }

  @Watch("selectedFields", { immediate: true })
  private changeSelectedFields() {
    if (
      this.selectedFields.includes(this.OWNER_NAME) &&
      !this.selectedFields.includes(this.OWNER_ID)
    ) {
      this.selectedFields.push(this.OWNER_ID);
    }
  }

  private onLinesConvertedError() {
    this.records = [];

    notificationService.addErrorNotification(
      i18n.t("notifications.error.bulk-csv-file-converter-parse") as string
    );
  }
  
  private onLinesConverted(it: BulkUploadDTO[]) {
    this.records = it;
  }

  private toggleFileUploadVisible() {
    this.isFileUploadVisible = !this.isFileUploadVisible;
  }
}
